// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"c0c359d6","453":"af205ec6","505":"8823a57d","563":"b0fe316e","810":"94ce7419","835":"f03c6464","854":"cd14e821","866":"fb99d44d","868":"fa03de74"}[chunkId] + ".chunk.js";
};